import { uniqBy } from 'lodash';
import { DeviceStatusAirConnectAPIResponse } from '../deviceStatus.model';
import getGatewayOffline from './getGatewayOffline';

function getSmartSwitchError(
  data: DeviceStatusAirConnectAPIResponse[] | undefined
) {
  const gatewayErrors =
    getGatewayOffline(data)?.map((item) => item.deviceID) ?? [];

  return (
    data &&
    uniqBy(
      data
        ?.filter((item) => !gatewayErrors.includes(item.deviceID))
        .filter((item) => item.lastResponseState === 'ERROR')
        ?.filter((item) => item.type === 2),
      'deviceID'
    )
  );
}

export default getSmartSwitchError;
